import * as types from '../actions/action-types';
import initialState from './orderSummaryInitialState';
import Status from '../../enums/Status';

export default function orderSummaryReducer(state = initialState, action) {
  switch (action.type) {
    case types.UPDATE_ORDER_SUMMARY:
      return {updatedReason: state.updatedReason, status: Status.SUCCESS, ...action.orderSummary};

    case types.SET_ORDER_SUMMARY_UPDATING:
      return {...state, status: Status.UPDATING, updatedReason: action.reason};

    case types.SET_ORDER_SUMMARY_ERROR:
      return {...state, status: Status.ERROR};
      
    case types.SET_ACCOUNT_CREDIT_MESSAGE:
      return {...state, credit: {...state.credit, message: action.message, messageType: action.messageType}};
      
    default:
      return state;
  }
}
